import {Service} from "./service";
export class ServiceSet {
  name: string;
  fullName: string;
  services: Service[] = [];
  active: boolean = false;
  index: number = 0;
}



// WEBPACK FOOTER //
// ./src/app/models/service-set.ts